import { render, staticRenderFns } from "./ResumeBuyerCampaignFromEmail.vue?vue&type=template&id=266e94c0&scoped=true"
import script from "./ResumeBuyerCampaignFromEmail.vue?vue&type=script&lang=js"
export * from "./ResumeBuyerCampaignFromEmail.vue?vue&type=script&lang=js"
import style0 from "./ResumeBuyerCampaignFromEmail.vue?vue&type=style&index=0&id=266e94c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266e94c0",
  null
  
)

export default component.exports